import { useCallback } from 'react';
import { useAuthToken } from '../features/auth/useAuthToken';
import { removeImpersonationToken, removeStoredToken } from '../services/apiClient';
import { hardNavigate } from '../utils/navigation';

/**
 * ログアウト処理の共通フック。
 *
 * サーバー側セッションを破棄 (`/auth/logout`) した後、成否にかかわらず
 * 保存済み JWT と代行 (impersonation) トークンを破棄し、アプリのルートへ
 * ハードナビゲートする (basename は hardNavigate が付与する)。
 *
 * 元 JWT を破棄するタイミングで代行トークンも必ず破棄すること (孤立を防ぐ)。
 */
export function useLogout(): () => void {
  const { setToken } = useAuthToken();

  return useCallback(() => {
    fetch('/auth/logout', { method: 'POST', credentials: 'include' })
      .catch((err: unknown) => {
        // サーバー側の破棄に失敗してもローカルのトークン破棄と遷移は行う
        // (未処理の Promise 拒否にしない)
        console.warn('Server-side logout failed; clearing local session anyway', err);
      })
      .finally(() => {
        removeStoredToken();
        removeImpersonationToken();
        setToken(null);
        hardNavigate('/');
      });
  }, [setToken]);
}
